const productRoot = document.querySelector("[data-product-page]");
const pageType = productRoot?.dataset.productPage || document.body.dataset.productPage;

if (pageType) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  });

  const config = {
    tumbler: {
      productLabel: "QR tumblers",
      unitLabel: "tumblers",
      unitPrice: 25,
      defaultColor: "#171b20",
      defaultColorLabel: "Black",
      quantity: 25,
      localCheckoutPath: "../checkout.html",
      shopifyFallbackPath: "/pages/order-review"
    },
    stickers: {
      productLabel: "Smart stickers",
      unitLabel: "stickers",
      unitPrice: 2,
      defaultColor: "#f7f4eb",
      defaultColorLabel: "White",
      quantity: 100,
      localCheckoutPath: "../checkout.html",
      shopifyFallbackPath: "/pages/order-review"
    }
  }[pageType];

  const state = {
    color: config.defaultColor,
    colorLabel: config.defaultColorLabel,
    shape: "house",
    quantity: config.quantity,
    logoName: "",
    logoUrl: "",
    logoPosition: { x: 50, y: 50 }
  };

  const mockupStage = document.querySelector("#mockupStage");
  const quantityInput = document.querySelector("#quantity");
  const quantityValue = document.querySelector("#quantityValue");
  const totalDue = document.querySelector("#totalDue");
  const previewMeta = document.querySelector("#previewMeta");
  const destinationUrl = document.querySelector("#destinationUrl");
  const summaryPanel = document.querySelector("#summaryPanel");
  const checkoutButton = document.querySelector("#checkoutButton");
  const brandName = document.querySelector("#brandName");
  const logoUpload = document.querySelector("#logoUpload");
  const logoFileName = document.querySelector("#logoFileName");
  const addonKit = document.querySelector("#addonKit");
  const formAlert = document.querySelector("#formAlert");

  function render() {
    state.quantity = Number(quantityInput.value);
    quantityValue.textContent = String(state.quantity);
    totalDue.textContent = formatter.format(total());
    updateRolloutState();
    previewMeta.textContent =
      pageType === "stickers" ? `${state.colorLabel} background` : `${state.colorLabel} · ${shapeLabel()}`;
    mockupStage.innerHTML = pageType === "stickers" ? stickerMockup() : tumblerMockup();
    renderSummary();
    if (pageType === "stickers") bindStickerDrag();
  }

  function tumblerMockup() {
    return `
      <div class="mock-product product-tumbler product-tumbler--page" style="--mock-color:${state.color}">
        <div class="flask-engraving">
          <strong>${escapeHtml(brandName?.value || "Your Brand")}</strong>
          <span class="shape-lockup shape-${state.shape}" aria-hidden="true">
            <span class="shape-name">${shapeLabel()}</span>
            <span class="qr-mark">${makeQrMarkup((destinationUrl.value || "qr-connect") + state.shape)}</span>
          </span>
        </div>
      </div>
    `;
  }

  function stickerMockup() {
    const logo = state.logoUrl
      ? `<img src="${state.logoUrl}" alt="" class="sticker-logo" style="left:${state.logoPosition.x}%; top:${state.logoPosition.y}%;">`
      : `<span class="sticker-empty">Upload logo</span>`;
    return `
      <div class="sticker-canvas-wrap">
        <div class="sticker-canvas ${state.colorLabel === "Black" ? "is-dark" : "is-light"}" style="--mock-color:${state.color}">
          ${logo}
        </div>
        <p class="sticker-caption">Click or drag to place the logo.</p>
      </div>
    `;
  }

  function bindStickerDrag() {
    const logo = mockupStage.querySelector(".sticker-logo");
    const canvas = mockupStage.querySelector(".sticker-canvas");
    if (!logo || !canvas) return;

    canvas.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      canvas.setPointerCapture(event.pointerId);

      const moveLogo = (moveEvent) => {
        const rect = canvas.getBoundingClientRect();
        const x = Math.min(88, Math.max(12, ((moveEvent.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(88, Math.max(12, ((moveEvent.clientY - rect.top) / rect.height) * 100));
        state.logoPosition = { x, y };
        logo.style.left = `${x}%`;
        logo.style.top = `${y}%`;
        renderSummary();
      };

      moveLogo(event);

      const stop = () => {
        canvas.removeEventListener("pointermove", moveLogo);
        canvas.removeEventListener("pointerup", stop);
        canvas.removeEventListener("pointercancel", stop);
      };

      canvas.addEventListener("pointermove", moveLogo);
      canvas.addEventListener("pointerup", stop);
      canvas.addEventListener("pointercancel", stop);
    });
  }

  function renderSummary() {
    const order = createOrderPayload();
    const addOnLine = order.addOns.length
      ? `<span>Launch kit: ${escapeHtml(order.addOns.map((item) => item.label).join(", "))}</span>`
      : "";
    if (pageType === "stickers") {
      summaryPanel.innerHTML = `
        <strong>${order.quantity} smart stickers · ${order.colorLabel} background</strong>
        <span>${state.logoName ? `Logo preview: ${escapeHtml(state.logoName)}` : "Production logo confirmed after checkout"}</span>
        <span>${order.destination || "Destination needed before checkout"}</span>
        <span>${formatPlacement()} placement</span>
        ${addOnLine}
        <span>${formatter.format(order.total)} estimated total</span>
      `;
    } else {
      summaryPanel.innerHTML = `
        <strong>${order.quantity} QR tumblers · ${order.colorLabel} · ${shapeLabel()}</strong>
        <span>${escapeHtml(order.brandName || "Brand name needed before checkout")}</span>
        <span>${order.destination || "Destination needed before checkout"}</span>
        ${addOnLine}
        <span>${formatter.format(order.total)} estimated total</span>
      `;
    }
  }

  function createOrderPayload() {
    return {
      productType: pageType,
      productLabel: config.productLabel,
      quantity: state.quantity,
      unitPrice: config.unitPrice,
      total: total(),
      color: state.color,
      colorLabel: state.colorLabel,
      destination: normalizeDestination(destinationUrl.value),
      brandName: brandName?.value || "",
      shape: pageType === "tumbler" ? state.shape : "",
      shapeLabel: pageType === "tumbler" ? shapeLabel() : "",
      addOns: selectedAddOns(),
      logo: pageType === "stickers"
        ? {
            name: state.logoName,
            dataUrl: state.logoUrl,
            placement: state.logoPosition
          }
        : null,
      createdAt: new Date().toISOString()
    };
  }

  async function handleCheckout() {
    const order = createOrderPayload();
    const validationErrors = validateOrder(order);
    if (validationErrors.length) {
      showFormAlert(validationErrors);
      return;
    }
    hideFormAlert();
    window.localStorage.setItem("qrconnect:lastOrder", JSON.stringify(order));

    checkoutButton.disabled = true;
    checkoutButton.textContent = "Preparing checkout";

    const variantId = shopifyVariantId(pageType, state.colorLabel);
    if (variantId) {
      try {
        await addToShopifyCart(order);
        window.location.href = "/checkout";
        return;
      } catch (error) {
        console.error(error);
        showFormAlert(["Checkout could not start. Try again or use the bulk-order link for help."]);
        checkoutButton.disabled = false;
        checkoutButton.textContent = "Continue to checkout";
        return;
      }
    }

    window.location.href = isShopifyStorefront() ? config.shopifyFallbackPath : config.localCheckoutPath;
  }

  function shopifyVariantId(productType, colorLabel) {
    const variants = window.QR_CONNECT_SHOPIFY_VARIANTS?.[productType];
    return variants?.[colorLabel] || variants?.[colorLabel.toLowerCase()] || "";
  }

  async function addToShopifyCart(order) {
    const properties = {
      "Destination link": order.destination,
      "Product color": order.colorLabel
    };

    if (order.productType === "tumbler") {
      properties["Brand name"] = order.brandName || "Pending";
      properties["Scan shape"] = order.shapeLabel;
    }

    if (order.productType === "stickers") {
      properties["Logo file"] = order.logo?.name || "Production logo to be confirmed";
      properties["Logo placement"] = formatPlacement();
    }

    const items = [
      {
        id: Number(shopifyVariantId(pageType, state.colorLabel)),
        quantity: order.quantity,
        properties
      },
      ...order.addOns
        .map((addOn) => {
          const addOnVariant = shopifyVariantId(addOn.productType, addOn.colorLabel);
          if (!addOnVariant) return null;
          return {
            id: Number(addOnVariant),
            quantity: addOn.quantity,
            properties: {
              "Launch kit add-on": addOn.label,
              "Paired with": order.productLabel,
              "Destination link": order.destination,
              "Product color": addOn.colorLabel
            }
          };
        })
        .filter(Boolean)
    ];

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error(`Shopify cart add failed: ${response.status}`);
    }
  }

  function isShopifyStorefront() {
    return Boolean(window.Shopify) || window.location.hostname.includes("useqrconnect.com");
  }

  function total() {
    return state.quantity * config.unitPrice + addOnTotal();
  }

  function selectedAddOns() {
    if (!addonKit?.checked) return [];
    const quantity = Number(addonKit.dataset.addonQuantity || 0);
    const unitPrice = Number(addonKit.dataset.addonUnitPrice || 0);
    return [
      {
        productType: addonKit.dataset.addonProduct,
        label: addonKit.dataset.addonLabel,
        quantity,
        unitPrice,
        colorLabel: addonKit.dataset.addonColorLabel || "Black",
        total: quantity * unitPrice
      }
    ];
  }

  function addOnTotal() {
    return selectedAddOns().reduce((sum, item) => sum + item.total, 0);
  }

  function validateOrder(order) {
    const errors = [];
    if (pageType === "tumbler" && !order.brandName.trim()) {
      errors.push("Add the brand or campaign name for the tumbler artwork.");
    }

    if (!order.destination) {
      errors.push("Add the destination link this product should send people to.");
    } else if (!isValidUrl(order.destination)) {
      errors.push("Use a complete destination link, like https://yourbrand.com/offer.");
    }

    return errors;
  }

  function isValidUrl(value) {
    try {
      const url = new URL(value);
      return ["http:", "https:"].includes(url.protocol) && url.hostname.includes(".");
    } catch {
      return false;
    }
  }

  function showFormAlert(errors) {
    if (!formAlert) return;
    formAlert.hidden = false;
    formAlert.innerHTML = `
      <strong>Before checkout</strong>
      ${errors.map((error) => `<span>${escapeHtml(error)}</span>`).join("")}
    `;
  }

  function hideFormAlert() {
    if (!formAlert) return;
    formAlert.hidden = true;
    formAlert.innerHTML = "";
  }

  function updateRolloutState() {
    document.querySelectorAll("[data-quantity-preset]").forEach((button) => {
      button.classList.toggle("active", Number(button.dataset.quantityPreset) === state.quantity);
    });
  }

  function shapeLabel() {
    const labels = {
      house: "House",
      book: "Book",
      cup: "Cup",
      globe: "Globe",
      custom: "Custom"
    };
    return labels[state.shape] || "House";
  }

  function formatPlacement() {
    return `${Math.round(state.logoPosition.x)}% x, ${Math.round(state.logoPosition.y)}% y`;
  }

  function normalizeDestination(value) {
    const trimmed = value.trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) return trimmed;
    return `https://${trimmed}`;
  }

  function makeQrMarkup(seed) {
    const hash = Math.abs(hashString(seed || "qr-connect"));
    let cells = "";
    for (let index = 0; index < 81; index += 1) {
      const row = Math.floor(index / 9);
      const col = index % 9;
      const finder =
        (row < 3 && col < 3) ||
        (row < 3 && col > 5) ||
        (row > 5 && col < 3);
      const on = finder || ((hash >> (index % 24)) + row * 7 + col * 11) % 3 === 0;
      cells += `<i style="opacity:${on ? 1 : 0}"></i>`;
    }
    return cells;
  }

  function hashString(value) {
    return [...value].reduce((hash, char) => {
      return (hash << 5) - hash + char.charCodeAt(0);
    }, 0);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  document.querySelectorAll("[data-color]").forEach((button) => {
    button.addEventListener("click", () => {
      document.querySelectorAll("[data-color]").forEach((item) => item.classList.remove("active"));
      button.classList.add("active");
      state.color = button.dataset.color;
      state.colorLabel = button.dataset.label;
      render();
      hideFormAlert();
    });
  });

  document.querySelectorAll("[data-shape]").forEach((button) => {
    button.addEventListener("click", () => {
      document.querySelectorAll("[data-shape]").forEach((item) => item.classList.remove("active"));
      button.classList.add("active");
      state.shape = button.dataset.shape;
      render();
      hideFormAlert();
    });
  });

  quantityInput.addEventListener("input", render);
  destinationUrl.addEventListener("input", () => {
    render();
    hideFormAlert();
  });
  checkoutButton.addEventListener("click", handleCheckout);
  if (brandName) {
    brandName.addEventListener("input", () => {
      render();
      hideFormAlert();
    });
  }
  if (addonKit) addonKit.addEventListener("change", render);

  document.querySelectorAll("[data-quantity-preset]").forEach((button) => {
    button.addEventListener("click", () => {
      quantityInput.value = button.dataset.quantityPreset;
      render();
    });
  });

  if (logoUpload) {
    logoUpload.addEventListener("change", (event) => {
      const [file] = event.target.files;
      if (!file) return;
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        state.logoName = file.name;
        state.logoUrl = reader.result;
        state.logoPosition = { x: 50, y: 50 };
        if (logoFileName) logoFileName.textContent = file.name;
        render();
      });
      reader.readAsDataURL(file);
    });
  }

  render();
}
